import React from "react";
import "./Profile.css";

const Profile = () => {
  return (
    <section className="profile-section" id="profile">
      <div className="profile-container">
        <h2 className="section-title">
          COMPANY <span className="highlight">PROFILE</span>
        </h2>

        <div className="profile-content">
          <p>
            <strong>Eaver Global Solutions Private Limited</strong> is a global
            engineering and manufacturing company delivering innovative
            energy, industrial, and automation solutions. Our expertise
            spans multiple sectors, including renewable energy, electrical
            systems, control panels, industrial harnesses, and turnkey
            project solutions.
          </p>

          <p>
            With offices in <strong>India</strong> and <strong>Kenya</strong>,
            Eaver has earned the trust of leading industries by providing
            cost-effective, reliable, and future-ready solutions.
          </p>

          <div className="profile-mission">
            <h3>Our Mission</h3>
            <p>
              To deliver high-quality electrical products and engineering
              services through technical excellence, innovation, and
              reliability, while building long-term partnerships and creating
              sustainable value for our customers worldwide
            </p>
          </div>

          <div className="profile-vision">
            <h3>Our Vision</h3>
            <p>
              To be a globally trusted electrical engineering partner,
              delivering innovative, reliable, and sustainable power
              solutions that drive industrial growth and infrastructure
              development
            </p>
          </div>

          <div className="profile-values">
            <h3>Our Core Values</h3>
            <ul>
              <li>
                <strong>Technical Integrity:</strong> We uphold the highest
                levels of engineering accuracy, compliance, and
                documentation—ensuring every solution meets IEC, IS, IEEE,
                and utility standards.
              </li>
              <br />
              <li>
                <strong>Execution Excellence:</strong> We focus on disciplined
                project execution, on-time delivery, and cost control,
                supporting EPCs and utilities in meeting critical project
                milestones.
              </li>
              <br />
              <li>
                <strong>Quality Assurance:</strong> Our products and services
                undergo stringent quality checks to ensure long-term
                reliability, minimal lifecycle risk, and predictable
                performance.
              </li>
              <br />
              <li>
                <strong>Safety & Compliance:</strong> We maintain
                uncompromising safety practices and regulatory adherence
                across all project phases, protecting people, assets, and
                reputation.
              </li>
              <br />
              <li>
                <strong>Partnership Mindset:</strong> We work as an extension
                of our clients’ teams, enabling seamless coordination with
                developers, EPCs, utilities, and financiers.
              </li>
              <br />
              <li>
                <strong>Risk Management & Accountability:</strong> We
                proactively identify and mitigate technical, operational,
                and project risks—taking ownership of outcomes and
                responsibilities.
              </li>
              <br />
              <li>
                <strong>Sustainability & Future Readiness:</strong> We
                support energy-efficient, resilient, and future-ready
                infrastructure aligned with long-term environmental and
                investment goals.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;
